import React, { useState } from "react";

const AssignShiftPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [assignShiftPopup, setAssignShiftPopup] = useState<boolean>(false);

    const assignShiftToggleHandler = () => {
      setAssignShiftPopup(!assignShiftPopup);
    };

    return (
      <Component
        assignShiftPopup={assignShiftPopup}
        assignShiftToggleHandler={assignShiftToggleHandler}
        {...props}
      />
    );
  };

export default AssignShiftPopupHOC;